import classnames from 'classnames';
import type { IPatientTaskWorklist } from '../../../common/interfaces/patientTaskWorklist';
import { PatientTaskStatus } from '../../../common/enums/patientTaskStatus';
import { translateKey } from '../../translate';
import { Icon, IconColor } from './common';
import { DisplayDatePassed } from './DisplayDatePassed';

interface IStatusLabelIconPatientTaskProps {
    patientTask: IPatientTaskWorklist;
    small?: boolean;
}

export function StatusLabelIconPatientTask(props: IStatusLabelIconPatientTaskProps) {
    if (!props.patientTask.statusLabel) {
        return null;
    }

    let icon: string;
    let color: IconColor | undefined;
    let statusBadge: string | undefined;

    switch (props.patientTask.statusLabel) {
        case PatientTaskStatus.completed:
            icon = 'closed';
            statusBadge = 'badge';
            break;
        case PatientTaskStatus.open:
            icon = 'todo';
            color = IconColor.primary;
            statusBadge = 'badge badge-todo';
            break;
        default:
            throw new Error(`StatusLabelIconPatientTask '${props.patientTask.statusLabel}' but no icon is available`);
    }

    return (
        <div className={classnames('status-label', props.small ? 'small' : '')}>
            <div className="row">
                <div className="col">
                    <div>
                        <Icon
                            color={color}
                            icon={icon}
                        />
                        <span className={statusBadge}>
                            {translateKey(`StatusLabelPatientTaskEnum.${props.patientTask.statusLabel}`)}
                        </span>
                    </div>
                    <DisplayDatePassed
                        className={statusBadge}
                        isTimeHidden
                        value={
                            props.patientTask.status === PatientTaskStatus.open
                                ? props.patientTask.sortDate
                                : props.patientTask.dateCompleted
                        }
                    />
                </div>
            </div>
        </div>
    );
}
